import { useAppSelector } from '@app/hooks/reduxHooks';
import React from 'react';
import 'react-quill/dist/quill.snow.css';
import * as S from './TextEditor.styles';

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    ['link', 'code'],
    ['clean'],
  ],
};

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'code',
];

interface OnChangeHandler {
  (e: unknown): void;
}

type Props = {
  value: string;
  placeholder: string;
  onChange: OnChangeHandler;
};

export const TextEditor: React.FC<Props> = ({ value, onChange, placeholder }) => {
  const isRTL = useAppSelector((state) => state.translation.isRtl);
  return (
    <>
      <S.ReactQuillWrapper
        theme="snow"
        value={value || ''}
        modules={modules}
        formats={formats}
        onChange={onChange}
        placeholder={placeholder}
        className={`${isRTL ? 'editor-rtl' : ''}`}
      />
    </>
  );
};
